/**
 * Linha do tempo (agrupada por dia) — compartilhada por Compra e Separação
 * (Bloco 5, 12/09/2026). `vocab` traz SITUACAO_LABEL/TONE; `campoItens` diz
 * de onde sai a contagem de itens (`qtd_itens` em compras, `total_itens`
 * em separação).
 */
import React, { useMemo } from "react";

import { Pill, TimelineDate, TimelineDay, TimelineItem } from "./styles";

function chaveDia(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString("pt-BR", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });
}

export default function LinhaTempo({ requisicoes, onAbrir, vocab, campoItens = "qtd_itens" }) {
  const grupos = useMemo(() => {
    const map = new Map();
    // requisicoes ja vem ordenada por -created_at do backend
    requisicoes.forEach((r) => {
      const dia = chaveDia(r.created_at);
      if (!map.has(dia)) map.set(dia, []);
      map.get(dia).push(r);
    });
    return Array.from(map.entries());
  }, [requisicoes]);

  return (
    <div>
      {grupos.map(([dia, itens]) => (
        <TimelineDay key={dia}>
          <TimelineDate>{dia}</TimelineDate>
          {itens.map((r) => (
            <TimelineItem key={r.id} onClick={() => onAbrir(r.id)}>
              <Pill $tone={vocab.SITUACAO_TONE[r.situacao]}>
                {vocab.SITUACAO_LABEL[r.situacao] || r.situacao}
              </Pill>
              <div style={{ minWidth: 0, flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 13, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {r.numero} · {r.cliente_nome || "Sem cliente"}
                </div>
                <div style={{ fontSize: 11, color: "var(--ink-3)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {r.projeto_resumo || "—"} · {r[campoItens]} itens
                </div>
              </div>
              <div style={{ fontSize: 12, color: "var(--ink-3)", flex: "0 0 auto" }}>
                {new Date(r.created_at).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}
              </div>
            </TimelineItem>
          ))}
        </TimelineDay>
      ))}
    </div>
  );
}
